import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/axiosConfig';
import { useAuth } from '../context/AuthContext';
import { hasNavPermission } from '../components/ProtectedRoute';
import { ADMIN_PERMISSION_KEYS } from '../permissions';
import './Home.css';

const QUICK_LINKS = [
  {
    to: '/enfunde',
    icon: '🎋',
    label: 'Control de Enfunde',
    desc: 'Registrar el enfunde semanal por lote y trabajador',
    color: '#4caf50',
    permission: 'production',
  },
  {
    to: '/enfunde/list',
    icon: '📋',
    label: 'Historial de Enfunde',
    desc: 'Ver y editar las hojas semanales guardadas',
    color: '#66bb6a',
    permission: 'production',
  },
  {
    to: '/ventas/formulario',
    icon: '📝',
    label: 'Formulario de Ventas',
    desc: 'Registrar una nueva hoja de cosecha',
    color: '#f59e0b',
    permission: 'ventas',
  },
  {
    to: '/ventas/historial',
    icon: '📦',
    label: 'Historial de Ventas',
    desc: 'Ver las hojas de cosecha registradas',
    color: '#fb923c',
    permission: 'ventas',
  },
  {
    to: '/administration',
    icon: '⚙️',
    label: 'Admin',
    desc: 'Configuración y catálogos del grupo',
    color: '#546e7a',
    permission: ADMIN_PERMISSION_KEYS,
  },
  {
    to: '/novedades',
    icon: '📰',
    label: 'Novedades',
    desc: 'Cambios recientes de la aplicación',
    color: '#7c3aed',
    permission: 'novedades',
  },
  {
    to: '/profile',
    icon: '👤',
    label: 'Perfil',
    desc: 'Los datos de tu cuenta',
    color: '#0ea5e9',
    permission: null,
  },
];

function canShowQuickLink(user, permission) {
  if (!permission) return true;
  const keys = Array.isArray(permission) ? permission : [permission];
  return keys.some((key) => hasNavPermission(user, key));
}

const Home = () => {
  const { user } = useAuth();
  const [now, setNow] = useState(new Date());
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    api.get('settings/').then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  const quickLinks = QUICK_LINKS.filter((link) => canShowQuickLink(user, link.permission));

  const dateStr = now.toLocaleDateString('es', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
  const timeStr = now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });

  const greeting = () => {
    const h = now.getHours();
    if (h < 12) return 'Buenos días';
    if (h < 18) return 'Buenas tardes';
    return 'Buenas noches';
  };

  return (
    <div className="home-root">
      <div className="home-hero">
        <div className="home-hero-card">
          <div>
            <h1 className="home-hero-title">
              {greeting()}, <span className="home-hero-name">{user.first_name || user.username}</span> 👋
            </h1>
            {settings?.welcome_message && (
              <p className="home-hero-message">{settings.welcome_message}</p>
            )}
          </div>
          <div className="home-hero-clock">
            <div className="home-clock-display">{timeStr}</div>
            <div className="home-clock-label">{dateStr}</div>
          </div>
        </div>
      </div>

      <section className="home-section">
        <h2 className="home-section-title">Acceso rápido</h2>
        <div className="home-quick-grid">
          {quickLinks.map((link) => (
            <Link key={link.to} to={link.to} className="home-quick-card" style={{ '--card-color': link.color }}>
              <div className="home-quick-icon-wrap">
                <span className="home-quick-icon">{link.icon}</span>
              </div>
              <div className="home-quick-body">
                <div className="home-quick-label">{link.label}</div>
                <div className="home-quick-desc">{link.desc}</div>
              </div>
              <span className="home-quick-arrow">›</span>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Home;
